import styles from './AdsResultsCountBadge.module.scss';

interface AdsResultsCountBadgeProps {
  total: number;
}

export const AdsResultsCountBadge = ({ total }: AdsResultsCountBadgeProps) => {
  const label =
    total === 0 ? 'No listings found' : `${total} ${total === 1 ? 'listing' : 'listings'} found`;

  return (
    <div aria-label={label} aria-live='polite' className={styles.badge} role='status'>
      {label}
    </div>
  );
};
